import { type UseFormReturn, useWatch } from 'react-hook-form';
import { useFormMethods } from '@hqo/multi-step-form';
import type { FieldConfig } from '../../../../hooks/use-ui-metadata-field-config.hook';
import type { CreateVisitFormV2Values } from '../../../../types/form-data.types';
import { InputField } from '../one-visitor/input-field';

interface NoteForReceptionProps {
  config: FieldConfig;
}

export const NoteForReception = ({ config }: NoteForReceptionProps): JSX.Element | null => {
  const form = useFormMethods() as unknown as UseFormReturn<CreateVisitFormV2Values>;
  const {
    register,
    control,
    formState: { errors },
  } = form;
  const value = useWatch({ control, name: 'noteForReception' });

  if (config.hidden) {
    return null;
  }

  return (
    <InputField
      id="noteForReception"
      name="noteForReception"
      register={register}
      error={errors.noteForReception}
      value={value ?? ''}
      labelKey="createVisitFormV2.visitStep.noteForReception"
      labelDefault="Note for reception"
      required={config.required}
      placeholderKey="createVisitFormV2.visitStep.placeholders.noteForReception"
      placeholderDefault="e.g. Direct to the 5th floor office"
    />
  );
};
